export default __webpack_public_path__ + "static/media/hrimg.04ec0e81.png";